import { render, staticRenderFns } from "./programs.vue?vue&type=template&id=c0d9267e&"
var script = {}
import style0 from "./programs.vue?vue&type=style&index=0&id=c0d9267e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports